"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M415.7 41.2H82.3c-23 0-41.7 18.7-41.7 41.7v333.3c0 23 18.7 41.7 41.7 41.7h333.3c23 0 41.7-18.7 41.7-41.7V82.8c0-23-18.6-41.6-41.6-41.6zM358 192.5v8c0 74-58 161.9-162 161.9-32 0-60-8-88-24h14c28 0 52-8 72-24-24 0-46-16-52-38h10c6 0 10 0 14-2-26-8-46-30-46-56 10 2 20 6 28 6-16-10-26-28-26-48 0-10 2-20 8-28 28 32 68 58 118 60 0-6-2-8-2-14 0-30 24-58 58-58 16 0 30 8 42 20 14-2 24-8 36-14-6 14-14 24-24 30 10 0 22-6 32-8-10 12.1-22 22.1-32 28.1z"
  });
};

exports.default = _default;